"use client";
import { createContext, useContext, useMemo, useState } from "react";
import { IPackages, IUserPackage } from "@/interfaces";

type PackagesContextValue = {
  packages: IPackages[];
  user: any;
  setPackages: (packages: IPackages[]) => void;
  setUser: (user: IUserPackage[]) => void;
};

const PackagesContext = createContext<PackagesContextValue | undefined>(
  undefined,
);

export function PackagesProvider({
  children,
  initialPackages,
  initialUser,
}: {
  children: React.ReactNode;
  initialPackages?: IPackages[];
  initialUser?: IUserPackage[];
}) {
  const [packages, setPackages] = useState<IPackages[]>(initialPackages ?? []);
  const [user, setUser] = useState<any>(initialUser ?? null);
  const value = useMemo(
    () => ({ packages, user, setPackages, setUser }),
    [packages, user],
  );

  return (
    <PackagesContext.Provider value={value}>
      {children}
    </PackagesContext.Provider>
  );
}

export function usePackages() {
  const ctx = useContext(PackagesContext);
  if (!ctx) throw new Error("usePackages must be used within PackagesProvider");
  return ctx;
}
